import { jsx as i } from "react/jsx-runtime";
function l(n) {
  return n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
const h = ({ text: n, highlight: c, className: s }) => {
  if (!c.trim())
    return /* @__PURE__ */ i("span", { className: s, children: n });
  const g = l(c), o = new RegExp(`(${g})`, "gi"), e = n == null ? void 0 : n.split(o);
  return /* @__PURE__ */ i("span", { className: s, children: e == null ? void 0 : e.map((r, p) => o.test(r) ? /* @__PURE__ */ i("strong", { children: r }, p) : r) });
};
export {
  h as H
};
